import React, { Fragment, Component } from "react";
import { accessRole } from "../../../../../helpers/access_role";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";
import PegawaiSideBar from "../../../GlobalComponents/PegawaiSidebar";
import CustomSelect from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
} from "../../../../../helpers/ui/FileInput";

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

var reformatOptionsParents = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

const jobType = [
  { value: 1, label: "PNS BKPM" },
  { value: 2, label: "PNS Non BKPM" },
  { value: 3, label: "Non PNS" },
  { value: 4, label: "Belum Bekerja" },
];

// const peg_uuid = JSON.parse(localStorage.getItem('userdata'))?.employee_uuid ?? "";
// const peg_name = JSON.parse(localStorage.getItem('userdata'))?.employee_name ?? "";

var reformatOptionRegion = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear() + 10,
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

class IndexView extends Component {
  createBloc = new CreateBloc();

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_uuid
      : "";
  peg_name = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_full_name
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_full_name
      : "";
  employee_current_position_name = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_current_position_name
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_current_position_name
      : "";
  peg_nip = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_nip
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_nip
      : "";

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      optionGender: [
        { label: "Laki-laki", value: "L" },
        { label: "Perempuan", value: "P" },
      ],
      optionStatus: [],
      optionMaritalStatus: [],
      birthOptionNationality: [
        { label: "Dalam Negeri", value: "Dalam Negeri" },
        { label: "Luar Negeri", value: "Luar Negeri" },
      ],
      optionCollege: [
        { label: "Ya", value: 1 },
        { label: "Tidak", value: 0 },
      ],
      optionParents: [],
      optionYears: createYearOption(new Date().getFullYear() - 20),
      birthOptionCountry: [],
      selectedGender: "",
      selectedStatus: "",
      birthOptionProvince: [],
      birthSelectedProvince: "",
      birthOptionCity: [],
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
      birthSelectedParents: "505bb7df-10b6-4cc5-92bd-0b2e23cddcc8", // Father
      birthSelectedCity: "",
      isLocal: 1,
      pnsStatus: 1,
      inCollege: 0,
      selectedDocType: null,
      selectedDocLabel: null,
      satkerGajiwebOption: [],
    };
  }

  // Select Area

  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
        isLocal: 1,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        isLocal: 0,
      });
    }
  };

  handleBirthSelectCountry = (birthSelectedCountry) => {
    let selected = birthSelectedCountry.value;
    this.getBirthProvinceByCountry(selected);
  };

  getBirthProvinceByCountry(selected_uuid) {
    this.createBloc.fetchRegionProvince({
      //is_local: 1,
      parent_uuid: selected_uuid,
      type: 2,
    });
  }

  handleBirthSelectProvince = (birthSelectedProvince) => {
    this.setState({
      birthSelectedProvince: birthSelectedProvince.value,
    });

    this.createBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: birthSelectedProvince.value,
    });
  };

  handleBirthSelectCity = (birthSelectedCity) => {
    this.setState({
      birthSelectedCity: birthSelectedCity.value,
    });
  };

  handleSelectGender = (selectedGender) => {
    this.setState({
      selectedGender: selectedGender.value,
    });
  };

  handleSelectStatus = (selectedStatus) => {
    this.setState({
      selectedStatus: selectedStatus.value,
    });
  };

  // End Select Area

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, "file_doc"); // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']

    await this.createBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        employee_uuid: this.peg_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    // get data parents
    this.createBloc.parentsChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              optionParents: reformatOptionsParents(
                response,
                "family_name",
                "family_name",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchParents({
      employee_uuid: this.peg_uuid,
    });

    // get data birth country
    this.createBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCountry: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRegionCountry({
      type: 1,
    });

    // get data city where province selected
    this.createBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCity: reformatOptionRegion(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    // get data birth province
    this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

    // get data province
    this.createBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionProvince: reformatOptionRegion(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRegionProvince({
      is_local: 1,
      type: 2,
    });

    // get data relationship status
    this.createBloc.relationshipStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              optionStatus: response.result,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRelationshipStatus({
      relationship_uuid: "b01e17d8-b0c7-49b0-b601-a192064dfea1", // anak
    });

    // get data marital status
    this.createBloc.maritalStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              optionMaritalStatus: response.result,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchMaritalStatus();

    // this.createBloc.satkerGajiWebChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       const employeeData = result?.data?.response?.data?.decryptData?.[0];

    //       this.setState({
    //         satkerGajiwebOption: employeeData || {},
    //         loadingSatkerGajiWeb: false,
    //       });

    //       break;

    //     case apiResponse.ERROR:
    //       this.setState({
    //         loadingSatkerGajiWeb: false,
    //       });
    //       break;

    //     default:
    //       break;
    //   }
    // });
    this.createBloc.fetchSatkerGajiWeb({
      nip: this.peg_nip,
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.parentsChannel.unsubscribe();
    this.createBloc.regionCountryChannel?.unsubscribe();
    this.createBloc.regionProvinceChannel?.unsubscribe();
    this.createBloc.regionCityChannel?.unsubscribe();
    this.createBloc.relationshipStatusChannel.unsubscribe();
    this.createBloc.maritalStatusChannel.unsubscribe();
    this.createBloc.satkerGajiWebChannel.unsubscribe();
  }

  render() {
    console.log(this.peg_nip);
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="anak" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Tambah Data Anak</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="relationship_uuid"
                      type="hidden"
                      value="b01e17d8-b0c7-49b0-b601-a192064dfea1"
                    />

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Nama Anak<span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="name"
                          placeholder="Nama..."
                          type="text"
                          errorMessage="Masukkan Nama"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="name"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Nomor Induk Kependudukan
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <AvField
                          name="family_identity_number"
                          placeholder="Nomor Induk Kependudukan..."
                          type="text"
                          errorMessage="Masukkan Nomor Induk Kependudukan"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="family_identity_number"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Nomor Kartu Keluarga
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="4">
                        <AvField
                          name="familty_family_card_number"
                          placeholder="Nomor Kartu Keluarga..."
                          type="text"
                          errorMessage="Masukkan Nomor Kartu Keluarga"
                          className="form-control"
                          id="familty_family_card_number"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Status Anak <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_relationship_status_uuid"
                          errorMessage="Pilih Status Anak"
                          optionLabel="family_relationship_status_name"
                          optionValue="family_relationship_status_uuid"
                          options={this.state.optionStatus}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status Anak"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Status Perkawinan <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_marital_status_uuid"
                          errorMessage="Pilih Status Perkawinan"
                          optionLabel="marital_status_name"
                          optionValue="marital_status_uuid"
                          options={this.state.optionMaritalStatus}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status Perkawinan"
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Sedang / Selesai Kuliah{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_is_currently_in_college"
                          errorMessage="Pilih Status"
                          options={this.state.optionCollege}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status"
                          onChange={(v) =>
                            this.setState({ inCollege: v.value })
                          }
                        />
                      </Col>
                    </Row>

                    {this.state.inCollege == 1 && (
                      <Fragment>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Nama Perguruan Tinggi
                            <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <AvField
                              name="family_college_name"
                              placeholder="Nama Perguruan Tinggi..."
                              type="text"
                              errorMessage="Masukkan Nama Perguruan Tinggi"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="family_college_name"
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Alamat Perguruan Tinggi
                            <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <AvField
                              name="family_college_place"
                              placeholder="Alamat Perguruan Tinggi..."
                              type="text"
                              errorMessage="Masukkan Alamat Perguruan Tinggi"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="family_college_place"
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Tahun Masuk<span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                            <CustomSelect
                              name="family_college_year_start"
                              errorMessage="Pilih Tahun Masuk"
                              options={this.state.optionYears}
                              validate={{ required: { value: true } }}
                              placeholder="Pilih Tahun Masuk"
                              defaultValue={new Date().getFullYear()}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Tahun Lulus (Jika sudah lulus)
                          </label>
                          <Col md="3">
                            <CustomSelect
                              name="family_college_year_graduate"
                              errorMessage="Pilih Tahun Lulus"
                              options={this.state.optionYears}
                              placeholder="Pilih Tahun Lulus"
                            />
                          </Col>
                        </Row>
                        {/* <Row className="mb-3">
                                                  <Label className="col-md-3 col-form-label">Upload Surat Keterangan Kuliah</Label>
                                                    <Col md="5">
                                                        <FileInput
                                                            name="file"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row>  */}
                      </Fragment>
                    )}

                    <hr />

                    <Row>
                      <Col md="5">
                        <label className="fw-bold">#Data Orang Tua</label>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Nama Orang Tua<span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="parent_name"
                          placeholder="Nama Orang Tua..."
                          type="text"
                          errorMessage="Masukkan Nama Orang Tua"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.peg_name}
                          disabled
                          id="parent_name"
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Pasangan<span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="wife_name"
                                                    placeholder="Nama Pasangan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Pasangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="wife_name"
                                                />
                                            </Col>
                                        </Row> */}

                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Nama Pasangan<span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="wife_name"
                          errorMessage="Pilih Nama Pasangan"
                          options={this.state.optionParents}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Nama Pasangan"
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pernikahan Ke <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="merried_count"
                                                    placeholder="Pernikahan Ke..."
                                                    type="number"
                                                    errorMessage="Masukkan Pernikahan Ke"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="merried_count"
                                                />
                                            </Col>
                                        </Row> */}
                    <hr />
                    <Row>
                      <Col md="5">
                        <label className="fw-bold">#Tempat Lahir</label>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Dalam / Luar Negeri{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="place_of_birth_national"
                          errorMessage="Pilih Dalam / Luar Negeri Lahir"
                          onChange={this.handleBirthSelectNationality}
                          options={this.state.birthOptionNationality}
                          validate={{ required: { value: true } }}
                          defaultValue="Dalam Negeri"
                          placeholder="Pilih Dalam / Luar Negeri Lahir"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Negara <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="place_of_birth_country_uuid"
                          errorMessage="Pilih Negara Lahir"
                          onChange={this.handleBirthSelectCountry}
                          options={this.state.birthOptionCountry}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Negara Lahir"
                          defaultValue={this.state.birthSelectedCountry}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label
                        htmlFor="tempat_alhir"
                        className="col-md-3 col-form-label"
                      >
                        Provinsi <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="birth_province_uuid"
                          errorMessage="Pilih Provinsi Lahir"
                          onChange={this.handleBirthSelectProvince}
                          options={this.state.birthOptionProvince}
                          validate={{
                            required: {
                              value: this.state.isLocal == 0 ? false : true,
                            },
                          }}
                          placeholder="Pilih Provinsi Lahir"
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Kota <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="place_of_birth_city_uuid"
                          errorMessage="Pilih Kota Lahir"
                          options={this.state.birthOptionCity}
                          validate={{
                            required: {
                              value: this.state.isLocal == 0 ? false : true,
                            },
                          }}
                          placeholder="Pilih Kota Lahir"
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 1 ? { display: "none" } : {}}
                    >
                      <label
                        htmlFor="place_of_birth_city_text"
                        className="col-md-3 col-form-label"
                      >
                        Kota <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="place_of_birth_city_text"
                          placeholder="Kota..."
                          type="text"
                          errorMessage="Masukkan Kota"
                          className="form-control"
                          validate={{
                            required: {
                              value: this.state.isLocal == 1 ? false : true,
                            },
                          }}
                          id="place_of_birth_city_text"
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="date_of_birth"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Lahir <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="date_of_birth"
                          placeholder="Tanggal Lahir..."
                          type="date"
                          errorMessage="Masukkan Tanggal Lahir"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="date_of_birth"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="gender"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Kelamin <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <Select
                          value={this.state.optionGender.filter(
                            (option) =>
                              option.value === this.state.selectedGender,
                          )}
                          onChange={this.handleSelectGender}
                          required="required"
                          options={this.state.optionGender}
                          classNamePrefix="select2-gender"
                        />

                        <AvField
                          name="gender"
                          type="hidden"
                          errorMessage="Pilih Jenis Kelamin"
                          validate={{ required: { value: true } }}
                          id="gender"
                          value={this.state.selectedGender}
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="profession"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pekerjaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="profession"
                                                    placeholder="Pekerjaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Pekerjaan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="profession"
                                                />
                                            </Col>
                                        </Row> */}
                    <Row className="mb-3">
                      <label
                        htmlFor="alamat"
                        className="col-md-3 col-form-label"
                      >
                        Alamat <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="identity_address"
                          placeholder="Alamat..."
                          type="textarea"
                          errorMessage="Masukkan Alamat"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="alamat"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="identity_postal_code"
                        className="col-md-3 col-form-label"
                      >
                        Kode Pos <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="identity_postal_code"
                          placeholder="Kode Pos..."
                          type="number"
                          errorMessage="Masukkan Kode Pos"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="identity_postal_code"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="phone_number"
                        className="col-md-3 col-form-label"
                      >
                        Nomor Telepon <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="phone_number"
                          placeholder="Nomor Telepon..."
                          type="number"
                          errorMessage="Masukkan Nomor Telepon"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="phone_number"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label
                        htmlFor="fieldJobType"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Pekerjaan : <span className="text-danger">*</span>
                      </Label>
                      <Col md="4">
                        <CustomSelect
                          name="jobType"
                          options={jobType}
                          isSearchable={false}
                          defaultValue={1}
                          onChange={(opt) =>
                            this.setState({ pnsStatus: opt.value })
                          }
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                    {this.state.pnsStatus !== 3 &&
                      this.state.pnsStatus !== 4 && (
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldNIP"
                            className="col-md-3 col-form-label"
                          >
                            NIP : <span className="text-danger">*</span>
                          </Label>
                          <Col md="4">
                            <AvField
                              name="nip"
                              placeholder="NIP..."
                              errorMessage="Masukkan NIP"
                              type="number"
                              className="form-control"
                              id="fieldNIP"
                              validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                      )}

                    {this.state.pnsStatus == 3 && (
                      <Row className="mb-3">
                        <label
                          htmlFor="profession"
                          className="col-md-3 col-form-label"
                        >
                          Pekerjaan <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                          <AvField
                            name="profession"
                            placeholder="Pekerjaan..."
                            type="text"
                            errorMessage="Masukkan Pekerjaan"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="profession"
                          />
                        </Col>
                      </Row>
                    )}

                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Dokumen <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_document_type"
                          errorMessage="Pilih Jenis Dokumen"
                          options={[
                            {
                              value: "file_akta_kelahiran",
                              label: "Akta Kelahiran",
                            },
                            {
                              value: "file_surat_kematian",
                              label: "Surat Kematian",
                            },
                            { value: "file_buku_nikah", label: "Buku Nikah" },
                            {
                              value: "file_surat_keterangan_kuliah",
                              label: "Surat Keterangan Kuliah",
                            },
                            {
                              value: "file_surat_keterangan_kerja",
                              label: "Surat Keterangan Kerja",
                            },
                          ]}
                          onChange={(v) => {
                            this.setState({
                              selectedDocType: v.value,
                              selectedDocLabel: v.label,
                            });
                          }}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Jenis Dokumen"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload Dokumen ({this.state.selectedDocLabel}){" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        <FileInput
                          name="file_doc"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <div className="form-check form-switch mb-3">
                          <AvCheckboxGroup
                            name="checkboxExample"
                            required
                            errorMessage="Agreement harus di centang"
                          >
                            <AvCheckbox
                              label="Saya yakin dan bertanggung jawab atas data ini"
                              value="1"
                            />
                          </AvCheckboxGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/home.html?anak">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      {/* <AvField
                        type="hidden"
                        name="employee_satker_code"
                        value={this.state.satkerGajiwebOption?.kdsatker}
                      /> */}
                      <AvField
                        type="hidden"
                        name="employee_nip"
                        value={this.peg_nip}
                      />
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?anak" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
